module.exports = __webpack_public_path__ + "static/media/errorWorkspace.ab5359ec.svg";